export default __webpack_public_path__ + "static/media/pearlcatcher.21af83ff.png";